class BESSAppProjectReport extends BESSAppBase {

    constructor() {
        super();
        this.reportContentAsync = $('.async-load-report-content');
        this.viewReportBtn = $('.app-btn-view-report');
        this.viewReportBtn.bindClickEvent(this, this.#onViewReport);

    }

    start() {
        this.api = BESSApp.instance.services.api.project.report;

        if ($('.app-force-generate-report').length > 0) {
            this.#onViewReport();
        }
    }

    #onViewReport() {
        if (!this.viewReportBtn.hasClass('disabled')) {
            this.viewReportBtn.addClass('disabled');
            this.api.reportStatus(false, this.#generateOrLoadReport.bind(this));
        }
    }

    #generateOrLoadReport(result) {
        if (result.report != null) {
            this.#goToReport(result.report);
        } else {
            this.reportContentAsync.ajaxLoadMe();
            this.showDoingWork(
                'Generating your report PDF',
                'Please wait whilst your document is generated.'
            );
            this.#startGenerating();
        }
    }

    #startGenerating() {
        if (!this.#hasReportLoaded()) {
            this.doDelayed(this.#startGenerating, 500);
            return;
        }

        this.doDelayed(function () {
            this.api.prepareReport(this.#monitorStatus.bind(this));
        }, 1000);
    }

    #monitorStatus(result) {
        if (result.charts === 0 && result.report != null) {
            this.#goToReport(result.report);
        } else {
            this.doDelayed(this.#checkStatus, 3000);
        }
    }

    #monitorStatusTimeout() {
        this.doDelayed(this.#checkStatus, 3000);
    }

    #checkStatus() {
        this.api.reportPDFStatus(false, this.#monitorStatus.bind(this), this.#monitorStatusTimeout.bind(this));
    }

    #hasReportLoaded() {
        return $('.app-project-report-content').length > 0;
    }

    #goToReport(reportUrl) {
        window.location.href = reportUrl;
    }
}